import axios from "axios";
import { useMapContext } from "./MapContext";
import React, { useState } from "react";
import { Box, Button, Slider, TextField, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";

interface AskQuestionProps {
  // TODO
}

const AskQuestion = (props: AskQuestionProps) => {
  // Used for the form
  const { selectedPoint, setSelectedPoint } = useMapContext();
  const [radius, setRadius] = useState(500); // Default radius in feet
  const [question, setQuestion] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [answer, setAnswer] = useState<any>(null);

  // Function to handle slider value change
  const handleRadiusChange = (event: Event, newValue: number | number[]) => {
    setRadius(newValue as number);
  };

  // Submits the question to the n8n webhook
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!selectedPoint) return;
    setAnswer(null);
    setSubmitting(true);

    try {
      const webhookUrl = process.env.REACT_APP_N8N_ASK_QUESTION_WEBHOOK_URL;
      if (!webhookUrl) {
        throw new Error(
          "REACT_APP_N8N_ASK_QUESTION_WEBHOOK_URL is not defined"
        );
      }
      const response = await axios.post(webhookUrl, {
        question: question,
        location: {
          latitude: selectedPoint.lat,
          longitude: selectedPoint.lng,
        },
        radiusFeet: radius,
      });

      // TODO: Set the response
      setAnswer(response.data?.message?.content);

      resetForm();
    } catch (err) {
      console.error("Error submitting question:", err);
      alert("Submission failed");
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setQuestion("");
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Latitude"
          value={selectedPoint?.lat}
          fullWidth
          margin="normal"
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Longitude"
          value={selectedPoint?.lng}
          fullWidth
          margin="normal"
          InputProps={{ readOnly: true }}
        />
        <Typography gutterBottom>Radius (in feet)</Typography>
        <Slider
          value={radius}
          onChange={handleRadiusChange}
          aria-labelledby="radius-slider"
          valueLabelDisplay="auto"
          step={100}
          min={100}
          max={5000}
        />
        <Typography>Selected Radius: {radius} feet</Typography>
        <TextField
          label="Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          fullWidth
          margin="normal"
          multiline
          rows={3}
          required
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={submitting}
          sx={{ marginTop: 2 }}
        >
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </form>
      {answer && <ReactMarkdown>{answer}</ReactMarkdown>}
    </Box>
  );
};

export default AskQuestion;
